import { Get } from "../utils/api";
import { Product } from "../../types/api/Product";
import { useQuery } from "react-query";
import { useAuth0 } from "@auth0/auth0-react";

export default (productId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  return useQuery<Product>(
    `product_${productId}`,
    async () => {
      return await Get<Product>(
        `/api/product/${productId}`,
        await getAccessTokenSilently()
      );
    },
    { enabled: productId !== "add" }
  );
};
